import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import VerticalSpan from "../../assets/icons/animated-horizontal-lines.gif";
import DownwardArrowsBlack from "../../assets/icons/downward-arrows-black.png";
import WhiteExes from "../../assets/icons/white-exes-animated.gif";
import sagasMainImg from "../../assets/images/sagas-section-img.gif";

const sxStyles = {
  mainContainer: {
    backgroundColor: "black",
    alignItems: { xs: "flex-start", md: "center", xl: "center" },
    display: "flex",
    backgroundSize: "cover",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
    height: { xs: "800px", md: "800px", xl: "650px" },
    paddingTop: { xs: "90px", md: "100px" },
  },
  content: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "flex-start",
    justifyContent: "flex-end",
    width: "1440px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    paddingTop: { xs: "70px", md: "190px" },
  },
  sectionText: {
    color: "white",
    fontSize: { xs: "16px", md: "24px" },
    fontFamily: "IBM Plex Sans",
    fontWeight: "400",
    lineHeight: { xs: "24px", md: "34px" },
    textAlign: "left",
    maxWidth: { xs: "355px", md: "100%" },
    paddingLeft: { xs: "20px", md: 0 },
  },
  p2Title: {
    color: "white",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "32px", md: "45px" },
    fontWeight: "700",
    lineHeight: { xs: "33px", md: "70px" },
    paddingBottom: "5px",
    position: "relative",
    top: "-70px",
  },
  title: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "36px", md: "45px" },
    fontWeight: "400",
    lineHeight: { xs: "37px", md: "65px" },
    marginRight: "13px",
    textAlign: { xs: "center", md: "left" },
  },
  secondTitle: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "35px", md: "65px" },
    marginRight: "13px",
    marginBottom: "32px",
  },
};

const SagasSection = () => {
  return (
    <Grid sx={sxStyles.mainContainer}>
      <Stack>
        <img
          src={VerticalSpan}
          alt={""}
          style={{
            position: "relative",
            width: "30px",
            height: "15px",
            top: "-330px",
            left: "-50px",
          }}
        />
        <img
          src={VerticalSpan}
          alt={""}
          style={{
            position: "relative",
            width: "30px",
            height: "15px",
            top: "-300px",
            left: "-50px",
          }}
        />
        <img
          src={VerticalSpan}
          alt={""}
          style={{
            position: "relative",
            width: "30px",
            height: "15px",
            top: "-270px",
            left: "-50px",
          }}
        />
      </Stack>
      <Stack
        sx={{
          display: "flex",
          marginTop: { xs: "0", md: "20px" },
          justifyContent: { xs: "center", md: "left" },
          alignItems: { xs: "center", md: "flex-start" },
          marginBottom: { xs: 0, md: "40px" },
          width: { xs: "85%", md: "75%" },
          paddingBottom: { xs: 0, md: 0, xl: "100px" },
        }}
      >
        <Typography
          sx={{
            color: "white",
            fontFamily: "IBM Plex Sans",
            fontSize: { xs: "36px", md: "45px" },
            fontWeight: "400",
            lineHeight: { xs: "37px", md: "50px" },
            marginLeft: { xs: 0, md: "230px" },
            textAlign: { xs: "center", md: "left" },
            marginBottom: "30px",
          }}
        >
          4.
        </Typography>
        <Stack sx={{ display: { xs: "none", md: "flex" } }}>
          <Typography sx={sxStyles.title}>COMPLETÁ EL 100% DE </Typography>
          <Typography sx={sxStyles.title}>TODAS LAS SAGAS</Typography>
        </Stack>
        <Stack sx={{ display: { xs: "flex", md: "none" } }}>
          <Typography sx={sxStyles.title}>COMPLETÁ EL </Typography>
          <Typography sx={sxStyles.title}>100% DE TODAS </Typography>
          <Typography sx={sxStyles.title}>LAS SAGAS</Typography>
        </Stack>
        <Typography
          sx={{
            color: "white",
            fontFamily: "p22-arts-and-crafts",
            fontSize: { xs: "32px", md: "45px" },
            fontWeight: "700",
            lineHeight: { xs: "33px", md: "70px" },
            paddingBottom: "5px",
            position: "absolute",
            bottom: { xs: "520px", md: "175px", xl: "160px" },
            left: { xs: "50px", md: "195px", xl: "255px" },
            display: { xs: "none", md: "flex" },
          }}
        >
          ANTES DEL 26/04
        </Typography>
        <Typography
          sx={{
            display: { xs: "flex", md: "none" },
            color: "white",
            fontFamily: "p22-arts-and-crafts",
            fontSize: { xs: "40px", md: "45px" },
            fontWeight: "700",
            lineHeight: { xs: "42px", md: "70px" },
            paddingBottom: "5px",
            position: "absolute",
            bottom: { xs: "430px", md: "175px" },
            left: { xs: "20px", md: "195px", xl: "255px" },
          }}
        >
          ANTES DEL 26/04
        </Typography>
      </Stack>
      <Stack>
        <Box
          sx={{
            height: { xs: "285px", md: "370px" },
            width: { xs: "345px", md: "440px" },
            backgroundImage: `url(${sagasMainImg})`,
            backgroundSize: "cover",
            position: "absolute",
            right: { xs: "15px", md: "100px", xl: "400px" },
            bottom: "100px",
          }}
        />
      </Stack>
      <Box
        sx={{
          width: "450px",
          height: "90px",
          position: "absolute",
          zIndex: 1,
          left: { xs: "-200px", md: "150px" },
          bottom: "-35px",
        }}
      >
        <img
          src={WhiteExes}
          style={{ width: "450px", height: "80px" }}
          alt={""}
        />
      </Box>
      <Box
        sx={{
          width: "450px",
          height: "90px",
          position: "absolute",
          zIndex: 1,
          right: { xs: "-200px", md: "15px" },
          bottom: { xs: "720px", md: "600px", xl: "570px" },
        }}
      >
        <img
          src={WhiteExes}
          style={{ width: "450px", height: "80px" }}
          alt={""}
        />
      </Box>
    </Grid>
  );
};

export default SagasSection;
